import { variantProvider } from '@/app'
import { Text, View } from '@/components'

export function ScoreScale({ score, text }) {
  const scales = ['-100', '0', '+100']
  const normalizedScore = (score + 100) / 2

  return (
    <View css={styles.wrapper}>
      <View variants={['row', 'gap:0.5']}>
        <Text variants={['p2', 'color:neutral9']} text={score.toString()} />
        <Text text={text} variants={['p2']} />
      </View>
      <View css={styles.progressWrapper}>
        {scales.map((_, index) => {
          const step = 100 / (scales.length - 1)
          const left = `calc(${step * index}% - ${index ? '0.5px' : ''})`
          return <View css={[styles.scale, { left }]} />
        })}
        <View css={[styles.pointer, { left: `calc(${normalizedScore}% - 8px)` }]} />
      </View>
      <View css={styles.captionWrapper}>
        {scales.map(scale => (
          <Text text={scale} variants={['p4']} />
        ))}
      </View>
    </View>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    wrapper: {
      ...theme.presets.column,
      ...theme.spacing.gap('4px'),
    },
    progressWrapper: {
      height: 4,
      ...theme.presets.fullWidth,
      backgroundColor: theme.colors.neutral3,
      ...theme.presets.relative,
    },
    scale: {
      ...theme.presets.absolute,
      height: 8,
      width: 1,
      backgroundColor: theme.colors.neutral3,
    },
    captionWrapper: {
      ...theme.presets.row,
      ...theme.presets.fullWidth,
      ...theme.presets.justifySpaceBetween,
    },
    pointer: {
      ...theme.sized(2),
      backgroundColor: theme.colors.primary3,
      borderRadius: theme.borderRadius.rounded,
      position: 'absolute',
      top: -6,
    },
  }),
  true,
)
